import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Details } from './Details';
import { useFile } from '@/hooks/v1';
import { RiskRange } from './RiskRange';
import { useApplicationContext } from '@/context/v1/Application/context';
import { ReportTemplate } from '@/components/views/Report/ReportTemplate';

const { useFormInstance } = Form;

export const Result = ({ file_id, report, reportId, sectors, onDownloadPDF, isLoadingPDF, onChangeComment }) => {
	const form = useFormInstance();
	const { organization, company,  sendReport, existsReport } = useApplicationContext();

	const resolvedReportId = reportId || report?.data?.id || '';

	const { file: updated_file } = useFile({
		organizationId: organization?.id,
		companyId: company?.id,
		fileId: file_id
	});

	const exists = existsReport({
		report_type: 'KIM_PP',
		file_id: file_id || '',
		company_id: company?.id,
		organization_id: organization?.id
	});

	function handleSendReport() {
		const request = {
			report_type: 'KIM_PP',
			id: resolvedReportId,
			company_id: company?.id,
			organization_id: organization?.id
		};
		sendReport(request, '/reporting');
	}

	const sections = [
		{
			title: I18n.get('Results'),
			component: <RiskRange reportData={report.data} />
		},
		{
			component: <Details reportData={report.data} />
		}
	];

	const isLoading = report?.isLoading || sectors?.isLoading || !report;
	const selectedSector = sectors.data.find((sector) => sector.id === updated_file.data.sector_id);

	return (
		<ReportTemplate
			title={I18n.get('KIM - Push and pull')}
			sections={sections}
			sector={selectedSector}
			fileData={updated_file.data}
			reportData={report.data}
			isLoading={isLoading}
			onDownloadPDF={onDownloadPDF}
			isLoadingPDF={isLoadingPDF}
			onChangeComment={onChangeComment}
			handleSendReport={handleSendReport}
			exists={exists}
		/>
	);
};
